import { render } from "./IndexCourse.vue?vue&type=template&id=4dda19e0&scoped=true"
import script from "./IndexCourse.vue?vue&type=script&lang=js"
export * from "./IndexCourse.vue?vue&type=script&lang=js"

import "./IndexCourse.vue?vue&type=style&index=0&id=4dda19e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dda19e0"]])

export default __exports__